module.exports = __webpack_public_path__ + "static/hexometer-logo-56afe0ed011532c14efe5449ea11b9e4.svg";